module.exports = __webpack_public_path__ + "img/sn.5b654e1a.svg";